import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  templateEmailList: [],
  templateEmailMeta: {},
  templateSMSList: [],
  templateSMSMeta: {},
  senderIdData: [],
  currentEmailPage: 1,
  emailPageSize: 10,
  currentSMSPage: 1,
  smsPageSize: 10,
  selectedEmailRowData: {},
  selectedSMSRowData: {},
  selectedTab: 0,
};

export const fetchEmailTemplateLists = createAsyncThunk(
  "emailTemplateSlice/fetchEmailTemplateLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getTemplateListing, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "template_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "template_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchSMSTemplateLists = createAsyncThunk(
  "smsTemplateSlice/fetchSMSTemplateLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getTemplateListing, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "template_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "template_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchSMSSenderIdData = createAsyncThunk(
  "smsTemplateSlice/fetchSMSSenderIdData",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getSenderIdData, {
        params: {},
      });
      dispatch(
        actions.setLoadingState({
          resource: "template_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const emailTemplateSlice = createSlice({
  name: "emailTemplateSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchEmailTemplateLists.pending, (state) => {
      state.templateEmailList = [];
    });
    builder.addCase(fetchEmailTemplateLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.templateEmailList = objects;
      state.templateEmailMeta = meta;
    });
    builder.addCase(fetchEmailTemplateLists.rejected, (state, action) => {});
  },
  reducers: {
    onPageAndPageSizeChangeEmail: (state, action) => {
      const { payload } = action;
      state.currentEmailPage = payload["currentPage"];
      state.emailPageSize = payload["pageSize"];
    },
    onEditEmailTemplate: (state, action) => {
      const { payload } = action;
      state.selectedEmailRowData = payload;
    },
  },
});
export const smsTemplateSlice = createSlice({
  name: "smsTemplateSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchSMSTemplateLists.pending, (state) => {
      state.templateSMSList = [];
    });
    builder.addCase(fetchSMSSenderIdData.fulfilled, (state, { payload }) => {
      const { data } = payload;
      // const { meta, objects } = data;
      state.senderIdData = data["sms_sender_ids"];
    });
    builder.addCase(fetchSMSTemplateLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.templateSMSList = objects;
      state.templateSMSMeta = meta;
    });
    builder.addCase(fetchSMSTemplateLists.rejected, (state, action) => {});
  },
  reducers: {
    onPageAndPageSizeChangeSMS: (state, action) => {
      const { payload } = action;
      state.currentSMSPage = payload["currentPage"];
      state.smsPageSize = payload["pageSize"];
    },
    onEditSMSTemplate: (state, action) => {
      const { payload } = action;
      state.selectedSMSRowData = payload;
    },
  },
});

export const tabbingTemplateSlice = createSlice({
  name: "tabbingTemplateSlice",
  initialState: { ...initialListingsState },
  reducers: {
    onTabChange: (state, action) => {
      const { payload } = action;
      state.selectedTab = payload;
    },
  },
});

export const {
  onPageAndPageSizeChangeEmail,
  onEditEmailTemplate,
} = emailTemplateSlice.actions;
export const {
  onPageAndPageSizeChangeSMS,
  onEditSMSTemplate,
} = smsTemplateSlice.actions;
export const { onTabChange } = tabbingTemplateSlice.actions;
